import { Predicate } from '€lib/types/fp';

const filter =
    <T>(predicate: Predicate<T>) =>
    (data: T[]) =>
        data.filter(predicate);

export default filter;
